module.exports = __webpack_public_path__ + "img/json.a25dd96b.svg";